import { Button, Theme, useTheme } from '@mui/material';

const MAX_PAGES_TO_PRINT = 6;

const createPagingItem = (pageToPrint: number, page: number, theme: Theme, onChangePage: (value: number) => void) => (
  <Button
    variant={pageToPrint === page? 'contained' : 'text'}
    key={pageToPrint}
    disabled={pageToPrint === page}
    sx={{
      minWidth: '40px',
      width: '40px',
      height: '40px',
      borderRadius: '20px',
      backgroundColor: pageToPrint === page ? theme.palette.field.main : 'auto',
      '&&:disabled': {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main,
      },
    }}
    onClick={() => onChangePage(pageToPrint)}
  >
    {pageToPrint}
  </Button>
);

export const usePaginationPages = (totalPages: number, page: number, onChangePage: (value: number) => void) => {
  const theme = useTheme();
  const pagesArray: JSX.Element[] = [];
  const pagesToPrint = page + MAX_PAGES_TO_PRINT > totalPages ? totalPages - page : page + MAX_PAGES_TO_PRINT;

  if (page + MAX_PAGES_TO_PRINT > totalPages) {
    for (let i = totalPages; i > totalPages - MAX_PAGES_TO_PRINT && i > 0; i--) {
      pagesArray.push(createPagingItem(i, page, theme, onChangePage));
    }
    pagesArray.reverse();
  } else {
    for (let i = page; i < pagesToPrint; i++) {
      pagesArray.push(createPagingItem(i, page, theme, onChangePage));
    }
  }

  return pagesArray;
};
